<template>
    <div class="main">
        <c-panel title="DISPONIBILIDADE DOS PROFESSORES" titleIcon="fas fa-user-clock">

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="A disponibilidade vale por escola e período letivo. Professor sem disponibilidade cadastrada NÃO fica indisponível: ele apenas não tem restrição registrada."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregar">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" class="u-text-right">
                        <el-button v-if="podeEscrever && instituicaoId && periodoId" type="primary" class="u-mt-25" @click="abrirNovo">NOVA DISPONIBILIDADE</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert v-if="diagnostico && diagnostico.aviso" type="warning" :closable="false" class="u-mb-15" :title="diagnostico.aviso"></el-alert>

            <el-row v-if="diagnostico" :gutter="10" class="u-mb-15">
                <el-col :xs="24" :sm="8" :md="8"><div class="u-text-center"><h3 class="u-mb-0">{{ diagnostico.lotados }}</h3><small>professores lotados</small></div></el-col>
                <el-col :xs="24" :sm="8" :md="8"><div class="u-text-center"><h3 class="u-mb-0">{{ diagnostico.com_disponibilidade }}</h3><small>com disponibilidade</small></div></el-col>
                <el-col :xs="24" :sm="8" :md="8"><div class="u-text-center"><h3 class="u-mb-0">{{ diagnostico.sem_disponibilidade }}</h3><small>sem restrição registrada</small></div></el-col>
            </el-row>

            <div class="container-table" v-if="instituicaoId && periodoId">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Professor</th>
                            <th>Dia</th>
                            <th>Abrangência</th>
                            <th class="hidden-mobile">Observação</th>
                            <th style="width: 130px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ item.servidor ? item.servidor.nome : item.servidor_id }}</td>
                            <td>{{ nomeDoDia[parseInt(item.dia_semana)] }}</td>
                            <td>{{ abrangencia(item) }}</td>
                            <td class="hidden-mobile">{{ item.observacao || '—' }}</td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever" @click="editar(item)" title="Editar" type="info" icon="el-icon-edit" size="mini" plain></el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever" @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0">
                            <td colspan="5" class="u-text-center">
                                Nenhuma disponibilidade cadastrada nesta escola e período.
                                Enquanto não houver cadastro, nenhum professor é considerado indisponível.
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <el-dialog :title="form.id ? 'Editar disponibilidade' : 'Nova disponibilidade'" :visible.sync="dialogo" width="620px">
                <el-form label-position="top" :model="form">

                    <el-alert type="info" :closable="false" class="u-mb-15"
                        title="Deixe horário e ordens em branco para declarar o DIA INTEIRO. Preencha a faixa OU as ordens de aula, conforme o que a escola controla."></el-alert>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="14">
                            <el-form-item label="Professor">
                                <el-select v-model="form.servidor_id" filterable remote :remote-method="buscarServidores"
                                           :loading="buscandoServidor" placeholder="Digite o nome" style="width: 100%;">
                                    <el-option v-for="s in servidores" :key="s.id" :value="s.id" :label="s.nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10">
                            <el-form-item label="Dias da semana">
                                <el-select v-model="form.dias" multiple style="width: 100%;">
                                    <el-option v-for="(nome, idx) in nomeDoDia" :key="idx" :value="idx" :label="nome"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="6">
                            <el-form-item label="Hora inicial">
                                <el-input v-model="form.hora_inicio" v-mask="'##:##'" placeholder="07:00"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6">
                            <el-form-item label="Hora final">
                                <el-input v-model="form.hora_fim" v-mask="'##:##'" placeholder="11:00"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Ordens de aula">
                                <el-select v-model="form.ordens_aula" multiple allow-create filterable default-first-option
                                           placeholder="Ex.: 1, 2, 3" style="width: 100%;">
                                    <el-option v-for="n in 10" :key="n" :value="n" :label="n + 'º horário'"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="Observação">
                        <el-input v-model="form.observacao" maxlength="255"></el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" @click="salvar">SALVAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/**
 * BLOCO F — item 79 do edital (Timbé do Sul/SC). Fase F10.
 *
 * Interface para `api/disponibilidade-professor`.
 *
 * ==================== DUAS AUSÊNCIAS DIFERENTES ====================
 *
 * A tela preserva visualmente a distinção que o backend faz:
 *
 *  · NENHUMA disponibilidade cadastrada  → sem restrição (o painel de diagnóstico conta
 *    esses professores e a listagem vazia diz isso em texto);
 *  · disponibilidade existente SEM aquele dia → o professor declarou seus dias, e aquele
 *    não está entre eles.
 *
 * `sem_restricao` NÃO virou checkbox nem regra local: quem decide é sempre a API.
 */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        statusList: false,
        instituicaoId: null,
        periodoId: null,
        instituicoes: [],
        items: [],
        diagnostico: null,
        servidores: [],
        buscandoServidor: false,
        dialogo: false,
        nomeDoDia: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        form: { id: null, servidor_id: null, dias: [], hora_inicio: '', hora_fim: '', ordens_aula: [], observacao: '' }
    }),
    computed: {
        podeEscrever () {
            return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo))
        }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) {
            this.instituicoes = [inst]
            this.instituicaoId = inst.id
            this.carregar()
        } else {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        }
    },
    methods: {
        carregar () {
            if (!this.instituicaoId || !this.periodoId) return
            this.statusList = false
            this.items = []

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/disponibilidade-professor/getPorInstituicao/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.statusList = true
                    return
                }
                this.items = Array.isArray(r.data) ? r.data : []
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/disponibilidade-professor/diagnostico/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.diagnostico = (r.data && !r.data.erro) ? r.data : null }).catch(() => {})
        },
        abrangencia (item) {
            const temFaixa = item.hora_inicio && item.hora_fim
            const temOrdens = Array.isArray(item.ordens_aula) && item.ordens_aula.length
            if (!temFaixa && !temOrdens) return 'Dia inteiro'
            const partes = []
            if (temFaixa) partes.push(String(item.hora_inicio).substring(0, 5) + ' às ' + String(item.hora_fim).substring(0, 5))
            if (temOrdens) partes.push(item.ordens_aula.join('º, ') + 'º horário')
            return partes.join(' · ')
        },
        buscarServidores (q) {
            if (!q || q.length < 3) return
            this.buscandoServidor = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/servidor/getAllPaginate?page=1`,
                { nome: q }, this.$store.getters.getHeaderAuth
            ).then(r => {
                this.servidores = (r.data && r.data.data) ? r.data.data : []
                this.buscandoServidor = false
            }).catch(() => { this.buscandoServidor = false })
        },
        abrirNovo () {
            this.form = { id: null, servidor_id: null, dias: [], hora_inicio: '', hora_fim: '', ordens_aula: [], observacao: '' }
            this.servidores = []
            this.dialogo = true
        },
        editar (item) {
            this.form = {
                id: item.id,
                servidor_id: item.servidor_id,
                dias: [parseInt(item.dia_semana)],
                hora_inicio: item.hora_inicio ? String(item.hora_inicio).substring(0, 5) : '',
                hora_fim: item.hora_fim ? String(item.hora_fim).substring(0, 5) : '',
                ordens_aula: item.ordens_aula || [],
                observacao: item.observacao || ''
            }
            this.servidores = item.servidor ? [item.servidor] : []
            this.dialogo = true
        },
        /**
         * `salvarLote` do backend SUBSTITUI toda a disponibilidade do professor naquela
         * escola e período — é atômico e valida o conjunto inteiro antes de gravar.
         * Por isso a tela envia a lista COMPLETA: o que já existia mais o que está sendo
         * cadastrado agora. Enviar só as linhas novas apagaria os demais dias.
         */
        salvar () {
            if (!this.form.servidor_id || !this.form.dias.length) {
                window.eventBus.$emit('alert', { msg: 'Informe o professor e ao menos um dia.', type: 'warning' })
                return
            }

            window.eventBus.$emit('loading', true)

            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/disponibilidade-professor/getPorServidor/${this.form.servidor_id}/${this.periodoId}?instituicao_id=${this.instituicaoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {

                const atuais = Array.isArray(r.data) ? r.data : []

                const linhas = atuais
                    .filter(x => parseInt(x.instituicao_id) === parseInt(this.instituicaoId))
                    // na edição, a linha alterada sai e volta com os novos valores
                    .filter(x => !this.form.id || parseInt(x.id) !== parseInt(this.form.id))
                    .map(x => ({
                        dia_semana: parseInt(x.dia_semana),
                        hora_inicio: x.hora_inicio ? String(x.hora_inicio).substring(0, 5) : null,
                        hora_fim: x.hora_fim ? String(x.hora_fim).substring(0, 5) : null,
                        ordens_aula: x.ordens_aula || [],
                        observacao: x.observacao || null,
                        situacao: true
                    }))

                this.form.dias.forEach(d => {
                    linhas.push({
                        dia_semana: parseInt(d),
                        hora_inicio: this.form.hora_inicio || null,
                        hora_fim: this.form.hora_fim || null,
                        ordens_aula: this.form.ordens_aula.map(o => parseInt(o)),
                        observacao: this.form.observacao || null,
                        situacao: true
                    })
                })

                return this.$axios.post(
                    `${this.$store.state.config.baseUrlApi}/api/disponibilidade-professor/salvarLote`,
                    {
                        servidor_id: this.form.servidor_id,
                        instituicao_id: this.instituicaoId,
                        periodo_letivo_id: this.periodoId,
                        disponibilidades: linhas
                    },
                    this.$store.getters.getHeaderAuth
                )
            }).then(r => {
                window.eventBus.$emit('loading', false)
                if (!r) return
                if (r.data && r.data.erro) {
                    // Mensagem do backend preservada: ela diz exatamente qual linha e por quê.
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Disponibilidade salva.', type: 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        excluir (id) {
            this.$confirm('Excluir esta disponibilidade?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/disponibilidade-professor/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Disponibilidade excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (erro) { return typeof erro === 'string' ? erro : (erro.text || 'Não foi possível concluir.') }
    }
}
</script>
